import * as React from 'react';
import { Flex } from '../../../Flex';
import { Badge } from '@/hen-ui/atomics/Badge';
import { Icon } from '@/hen-ui/atomics/Icon';
import type { BadgeListCellValue, ComparisonRowDef } from '../../types';

interface BadgeListCellProps {
  value: BadgeListCellValue | undefined;
  rowDef: Extract<ComparisonRowDef, { type: 'badgeList' }>;
}

export const BadgeListCell: React.FC<BadgeListCellProps> = ({
  value,
  rowDef,
}) => {
  if (!value?.badges || value.badges.length === 0) {
    console.error(
      '[BadgeListCell] No badges provided. BadgeListCell requires at least one badge.',
    );
    return null;
  }

  const uniformVariant =
    rowDef.badgeVariant ?? value.badges.find((badge) => badge.variant)?.variant;
  const uniformSize = rowDef.badgeSize ?? 'sm';

  return (
    <Flex direction='row' wrap='wrap' gap='xs'>
      {value.badges.map((badge, index) => {
        const resolvedVariant = uniformVariant ?? badge.variant;
        const resolvedSize = uniformSize;

        return (
          <Badge
            key={`${badge.text}-${index}`}
            variant={resolvedVariant}
            size={resolvedSize}
          >
            {badge.icon && <Icon icon={badge.icon} size='sm' aria-hidden />}
            {badge.text}
          </Badge>
        );
      })}
    </Flex>
  );
};

BadgeListCell.displayName = 'BadgeListCell';
